import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthorizationOptions} from '../components/authorization-options/AuthorizationOptions';

@Injectable()
export class AuthorizationOptionsService {

  constructor(private _http: HttpClient) {
  }

  saveAuthOptions(authorizationOptions) {
    return this._http.post('api/authorization-options/saveOptions', authorizationOptions);
  }

  getAuthOptions() {
    return this._http.get<AuthorizationOptions>('api/s/authorization-options/getOptions');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/services/authorization-options.service.ts